import React, { useState } from 'react';
import { toast } from 'sonner';
import { FacebookIcon, InstagramIcon, TwitterIcon, YoutubeIcon, LinkedinIcon, MapPinIcon, PhoneIcon, MailIcon, ArrowRightIcon, CreditCardIcon, ChevronDownIcon, ChevronUpIcon, WalletIcon, GlobeIcon } from 'lucide-react';
export function Footer() {
  const [quickLinksOpen, setQuickLinksOpen] = useState(false);
  const [customerServiceOpen, setCustomerServiceOpen] = useState(false);
  const [shopByCategoryOpen, setShopByCategoryOpen] = useState(false);
  return <footer className="bg-white border-t border-gray-200 mt-8" data-id="element-2737" data-mp="3s140y6vesuzr">
      {/* Assistance Section (Replaces Newsletter) */}
      <div className="bg-[#f0f7ff] border-b border-gray-200" data-id="element-2738" data-mp="3n1ho3yjhtgrh">
        <div className="container mx-auto px-4 py-6 md:py-10" data-id="element-2739" data-mp="3j3a4mvxna1cl">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-6 md:gap-8" data-id="element-2740" data-mp="3e2meech8pojf">
            {/* Left side: Text */}
            <div className="text-center lg:text-left" data-id="element-2741" data-mp="39543igjnwz8s">
              <h2 className="text-lg md:text-2xl font-bold text-[#1E2B55] mb-1 md:mb-2" data-id="element-2742" data-mp="2kd4k8memf48m">
                Need Assistance? We're Here to Help!
              </h2>
              <p className="text-gray-600 text-xs md:text-base max-w-2xl" data-id="element-2743" data-mp="2p54hg73b3j1i">
                Have questions or need support? Our team is just a call or chat
                away. Reach out to us anytime for quick and friendly assistance.
              </p>
            </div>

            {/* Right side: Contact buttons */}
            <div className="flex flex-col sm:flex-row items-center gap-3 md:gap-4 w-full sm:w-auto" data-id="element-2744" data-mp="33z9cepldyvd4">
              {/* Phone Support */}
              <div className="bg-white rounded-xl p-3 md:p-4 shadow-sm border border-blue-100 flex items-center gap-3 md:gap-4 w-full sm:min-w-[240px] md:min-w-[280px]" data-id="element-2745" data-mp="2u3piu9uao8rj">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-blue-50 flex items-center justify-center flex-shrink-0 border border-blue-100" data-id="element-2746" data-mp="1inr35n4m2ohc">
                  <PhoneIcon className="w-5 h-5 md:w-6 md:h-6 text-[#0066CC]" data-id="element-2747" data-mp="1nnnbtzo97438" />
                </div>
                <div className="flex flex-col" data-id="element-2748" data-mp="13k7v49w92vmz">
                  <span className="text-[10px] md:text-xs text-gray-500 font-medium whitespace-nowrap" data-id="element-2749" data-mp="zje77git5gu3">
                    Got Question? Call us 24/7
                  </span>
                  <a href="tel:043441122" className="text-base md:text-lg font-bold text-[#0066CC] hover:underline" data-id="element-2750" data-mp="uqb9qxawtn8m">
                    043441122
                  </a>
                </div>
              </div>

              {/* Chat Support */}
              <div className="bg-white rounded-xl p-3 md:p-4 shadow-sm border border-blue-100 flex items-center gap-3 md:gap-4 w-full sm:min-w-[240px] md:min-w-[280px]" data-id="element-2751" data-mp="fxhw7hf77h6l">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-blue-50 flex items-center justify-center flex-shrink-0 border border-blue-100" data-id="element-2752" data-mp="6w1lf8kh1d1u">
                  <MailIcon className="w-5 h-5 md:w-6 md:h-6 text-[#0066CC]" data-id="element-2753" data-mp="217yfzae7mz14" />
                </div>
                <div className="flex flex-col" data-id="element-2754" data-mp="28sitj4k2q7ht">
                  <span className="text-[10px] md:text-xs text-gray-500 font-medium whitespace-nowrap" data-id="element-2755" data-mp="28rqvzo6x1zow">
                    24/7 chat support
                  </span>
                  <button onClick={() => window.openAuthModal?.()} className="text-base md:text-lg font-bold text-[#0066CC] hover:underline text-left" data-id="element-2756" data-mp="2ihkaawyg0swu">
                    Chat with Us
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-6 md:py-10" data-id="element-2757" data-mp="1zq9jsgwmqi5h">
        {/* Mobile: Brand Block (Reduced - No Contact Info) */}
        <div className="md:hidden mb-4" data-id="element-2758" data-mp="23uh7qbv9ju2n">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8onJCNEDDvmSU1TZkPymCw/English.png" alt="Innova Pharmacy" className="h-8 mb-3" data-id="element-2759" data-mp="3b6rh0j81wot6" />
          <p className="text-xs text-gray-600 mb-3 line-clamp-2" data-id="element-2760" data-mp="3dqxmivcbcnbu">
            Your trusted source for premium healthcare products and pharmacy
            services.
          </p>
          <div className="flex space-x-2 mb-4" data-id="element-2761" data-mp="38txguljdlml9">
            <a href="#" className="bg-[#1E2B55] text-white p-1.5 rounded-full hover:bg-[#162041] transition-colors" data-id="element-2762" data-mp="3npdawqjyhihn">
              <FacebookIcon className="w-3.5 h-3.5" data-id="element-2763" data-mp="3isd58gr0qhr2" />
            </a>
            <a href="#" className="bg-[#1E2B55] text-white p-1.5 rounded-full hover:bg-[#162041] transition-colors" data-id="element-2764" data-mp="it4j97lfi04">
              <InstagramIcon className="w-3.5 h-3.5" data-id="element-2765" data-mp="aaqfqfylq9yu" />
            </a>
            <a href="#" className="bg-[#1E2B55] text-white p-1.5 rounded-full hover:bg-[#162041] transition-colors" data-id="element-2766" data-mp="ac1neqv641v8">
              <TwitterIcon className="w-3.5 h-3.5" data-id="element-2767" data-mp="jbok4zcycjhy" />
            </a>
            <a href="#" className="bg-[#1E2B55] text-white p-1.5 rounded-full hover:bg-[#162041] transition-colors" data-id="element-2768" data-mp="f9tlk2meok7v">
              <YoutubeIcon className="w-3.5 h-3.5" data-id="element-2769" data-mp="xvhkj9jme1yb" />
            </a>
            <a href="#" className="bg-[#1E2B55] text-white p-1.5 rounded-full hover:bg-[#162041] transition-colors" data-id="element-2770" data-mp="12vdtln76cjkq">
              <LinkedinIcon className="w-3.5 h-3.5" data-id="element-2771" data-mp="tvqp2sj5exng" />
            </a>
          </div>
        </div>
        {/* Mobile: Collapsible Sections */}
        <div className="md:hidden space-y-0 border-t border-gray-200" data-id="element-2772" data-mp="f6b2loqnhedk">
          {/* Shop by Category Accordion */}
          <div data-id="element-2773" data-mp="jz45s86h0enj">
            <button onClick={() => setShopByCategoryOpen(!shopByCategoryOpen)} className="w-full flex items-center justify-between py-3 border-b border-gray-200" data-id="element-2774" data-mp="jznpnufold47">
              <h3 className="text-sm font-semibold" data-id="element-2775" data-mp="3sdmiin7cwidh">Shop by Category</h3>
              {shopByCategoryOpen ? <ChevronUpIcon className="w-5 h-5 text-gray-600" data-id="element-2776" data-mp="171uzdgifsl7" /> : <ChevronDownIcon className="w-5 h-5 text-gray-600" data-id="element-2777" data-mp="22wh5mxmcvjcw" />}
            </button>
            {shopByCategoryOpen && <ul className="space-y-2 pt-3 pb-2" data-id="element-2778" data-mp="1y4pofdp3apzf">
                <li data-id="element-2779" data-mp="1u46vfgbgndvn">
                  <a href="/category/prescription-medicines" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2780" data-mp="1u3nnmsfiy5vc">
                    <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2781" data-mp="2lv3c6s0n62o7" />
                    Prescription Medicines
                  </a>
                </li>
                <li data-id="element-2782" data-mp="2hrnd7p13nq8c">
                  <a href="/category/vitamins-supplements" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2783" data-mp="2cuojh7lcllao">
                    <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2784" data-mp="27xy990w85jx6" />
                    Vitamins & Supplements
                  </a>
                </li>
                <li data-id="element-2785" data-mp="weu2itecqnom">
                  <a href="/category/personal-care" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2786" data-mp="wihys0b6lo71">
                    <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2787" data-mp="rbunjvjcwt1e" />
                    Personal Care
                  </a>
                </li>
                <li data-id="element-2788" data-mp="111wdytz6mnjh">
                  <a href="/category/mother-baby" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2789" data-mp="112fr7xdw0nr6">
                    <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2790" data-mp="1a19lhh3qx21k" />
                    Mother & Baby
                  </a>
                </li>
                <li data-id="element-2791" data-mp="1ez2usj0cic62">
                  <a href="/category/medical-devices" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2792" data-mp="1jzyuslhkte67">
                    <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2793" data-mp="3lrlpax0ofr7f" />
                    Medical Devices
                  </a>
                </li>
                <li data-id="element-2794" data-mp="1righjtegqph4">
                  <a href="/category/health-wellness" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2795" data-mp="1rhwy2895zt0z">
                    <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2796" data-mp="2191c95r0n9ur" />
                    Health & Wellness
                  </a>
                </li>
                <li data-id="element-2797" data-mp="18kdpf5qmccf3">
                  <a href="/category/beauty-skincare" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2798" data-mp="18lymb20eo7g4">
                    <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2799" data-mp="1hltx35q1u0fm" />
                    Beauty & Skincare
                  </a>
                </li>
                <li data-id="element-2800" data-mp="1dmcssfmcz9c1">
                  <a href="/categories" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2801" data-mp="2t0h2ravp1gq9">
                    <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2802" data-mp="2p1hw9lubdbwp" />
                    View All Categories
                  </a>
                </li>
              </ul>}
          </div>
          {/* Quick Links Accordion */}
          <div data-id="element-2803" data-mp="2mljv0zngzu2c">
            <button onClick={() => setQuickLinksOpen(!quickLinksOpen)} className="w-full flex items-center justify-between py-3 border-b border-gray-200" data-id="element-2804" data-mp="2mls5kkw4enad">
              <h3 className="text-sm font-semibold" data-id="element-2805" data-mp="3fah0212o7ud5">Quick Links</h3>
              {quickLinksOpen ? <ChevronUpIcon className="w-5 h-5 text-gray-600" data-id="element-2806" data-mp="3k7pkk8bakahk" /> : <ChevronDownIcon className="w-5 h-5 text-gray-600" data-id="element-2807" data-mp="35ib7oq8ibaxf" />}
            </button>
            {quickLinksOpen && <ul className="space-y-2 pt-3 pb-2" data-id="element-2808" data-mp="3agcvfogvnyf8">
                <li data-id="element-2809" data-mp="21kzc4pgclsk">
                  <a href="/account" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2810" data-mp="212wuqc75bc7">
                    <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2811" data-mp="sh819snta56s" />
                    My Account
                  </a>
                </li>
                <li data-id="element-2812" data-mp="wgyvy7ggl5gl">
                  <a href="/account/orders" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2813" data-mp="ijk4yyak4pmi">
                    <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2814" data-mp="nk7uffj50yem" />
                    Orders & Tracking
                  </a>
                </li>
                <li data-id="element-2815" data-mp="dl8sefsvo10l">
                  <a href="/account/wishlist" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2816" data-mp="dliaziblf5w9">
                    <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2817" data-mp="4sort9t0zmd4" />
                    Wishlist
                  </a>
                </li>
                <li data-id="element-2818" data-mp="3qz3ubm83xnwa">
                  <a href="/cart" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2819" data-mp="3qzmzs3gkmjtf">
                    <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2820" data-mp="37f4yrlvyo0t3" />
                    Shopping Cart
                  </a>
                </li>
                <li data-id="element-2821" data-mp="3hcj0efd86l1c">
                  <a href="/store-locator" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2822" data-mp="3hcsuof5azecu">
                    <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2823" data-mp="3qb4kwg29ca4r" />
                    Store Locator
                  </a>
                </li>
                <li data-id="element-2824" data-mp="3wlfh8v9g5af">
                  <a href="/brands" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2825" data-mp="3x4kxq3q517k">
                    <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2826" data-mp="3v58s90ffqk6d" />
                    Shop by Brand
                  </a>
                </li>
                <li data-id="element-2827" data-mp="8wzdrz7280v9">
                  <a href="/offers" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2828" data-mp="8xix9kccyxbe">
                    <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2829" data-mp="kz0nyfe5zfzv" />
                    Deals & Offers
                  </a>
                </li>
                <li data-id="element-2830" data-mp="pv91xpgml35g">
                  <a href="/about-us" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2831" data-mp="uoaie1whdar5">
                    <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2832" data-mp="zp7wa2agjimu" />
                    About Us
                  </a>
                </li>
              </ul>}
          </div>
          {/* Customer Service Accordion */}
          <div data-id="element-2833" data-mp="1dmwlfmbk5bxp">
            <button onClick={() => setCustomerServiceOpen(!customerServiceOpen)} className="w-full flex items-center justify-between py-3 border-b border-gray-200" data-id="element-2834" data-mp="1dlbpptdibmy9">
              <h3 className="text-sm font-semibold" data-id="element-2835" data-mp="3fejdzsb3lewa">Customer Service</h3>
              {customerServiceOpen ? <ChevronUpIcon className="w-5 h-5 text-gray-600" data-id="element-2836" data-mp="37vtc0lum8m70" /> : <ChevronDownIcon className="w-5 h-5 text-gray-600" data-id="element-2837" data-mp="33279vnm2w0pg" />}
            </button>
            {customerServiceOpen && <ul className="space-y-2 pt-3 pb-2" data-id="element-2838" data-mp="2t5lzsnv7bzer">
                <li data-id="element-2839" data-mp="2t75ism88sok8">
                  <a href="/help-center" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2840" data-mp="2t3hqfqeja873">
                    <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2841" data-mp="3lut09se7uz2n" />
                    Help Center
                  </a>
                </li>
                <li data-id="element-2842" data-mp="3bwc50j88vyas">
                  <a href="/faq" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2843" data-mp="3bwvc14wcx2a1">
                    <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2844" data-mp="20gwzgr1yzy42" />
                    FAQ
                  </a>
                </li>
                <li data-id="element-2845" data-mp="3pa2vk1s7auv6">
                  <a href="/contact-us" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2846" data-mp="3p9t6qhiw6tr2">
                    <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2847" data-mp="3fdzku7ja9nwm" />
                    Contact Us
                  </a>
                </li>
                <li data-id="element-2848" data-mp="3k9omqhirzgw3">
                  <a href="/track-order" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2849" data-mp="bvogdry9n7rs">
                    <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2850" data-mp="gsydltrwcnq6" />
                    Track My Order
                  </a>
                </li>
                <li data-id="element-2851" data-mp="6vtpvpiekk79">
                  <a href="/shipping-policy" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2852" data-mp="6va7y8sr5vt8">
                    <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2853" data-mp="2ro58dr2vm1cw" />
                    Shipping Policy
                  </a>
                </li>
                <li data-id="element-2854" data-mp="14qwcm6u5hfjh">
                  <a href="/return-policy" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2855" data-mp="14rfjmsi9ijiq">
                    <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2856" data-mp="1ep3edifvbr0w" />
                    Returns & Refunds
                  </a>
                </li>
                <li data-id="element-2857" data-mp="qzrb0z782d6i">
                  <a href="/terms-conditions" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2858" data-mp="qwv96zs974cs">
                    <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2859" data-mp="zsuhgnjg9prn" />
                    Terms & Conditions
                  </a>
                </li>
                <li data-id="element-2860" data-mp="7agtrgrtvk6a">
                  <a href="/privacy-policy" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2861" data-mp="79xl6qo2i84x">
                    <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2862" data-mp="22f6p43e5l7wr" />
                    Privacy Policy
                  </a>
                </li>
                <li data-id="element-2863" data-mp="27bf33dgm6v2c">
                  <a href="/report-issue" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2864" data-mp="2c4hxfnt7u8jl">
                    <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2865" data-mp="2h5e243le5yq2" />
                    Report an Issue
                  </a>
                </li>
              </ul>}
          </div>
          {/* Payment Methods - Always Visible (No Accordion) */}
          <div className="py-4 border-b border-gray-200" data-id="element-2866" data-mp="1tcxivppx40p6">
            <div className="flex items-center justify-start flex-wrap gap-2" data-id="element-2867" data-mp="1ycjww1dklkz1">
              <img src="https://cdn.niceonesa.com/web/assets_v2/images/visa.svg?v=2.1.18" alt="Visa" className="h-6 w-auto" data-id="element-2868" data-mp="1yagwqoipebgl" />
              <img src="https://cdn.niceonesa.com/web/assets_v2/images/master-card.svg?v=2.1.18" alt="Mastercard" className="h-6 w-auto" data-id="element-2869" data-mp="39u3382mg641t" />
              <img src="https://cdn.niceonesa.com/web/assets_v2/images/mada.svg?v=2.1.18" alt="Mada" className="h-6 w-auto" data-id="element-2870" data-mp="t7mwk2rdnw5u" />
              <img src="https://cdn.niceonesa.com/web/assets_v2/images/stc-pay.svg?v=2.1.18" alt="STC Pay" className="h-6 w-auto" data-id="element-2871" data-mp="jfgyqceg2kiq" />
              <img src="https://cdn.niceonesa.com/web/assets_v2/images/apple-pay.svg?v=2.1.18" alt="Apple Pay" className="h-6 w-auto" data-id="element-2872" data-mp="adr5d1105bib" />
              <img src="https://cdn.niceonesa.com/web/assets_v2/images/tamara.svg?v=2.1.18" alt="Tamara" className="h-6 w-auto" data-id="element-2873" data-mp="iph07ejwdgs" />
            </div>
          </div>
        </div>
        {/* Desktop: Grid Layout */}
        <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-[1.2fr_1fr_1fr_1fr] gap-6 md:gap-8" data-id="element-2874" data-mp="13ql37nm0381o">
          {/* Column 1: About */}
          <div className="lg:col-span-1" data-id="element-2875" data-mp="18qpijab69wqb">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8onJCNEDDvmSU1TZkPymCw/English.png" alt="Innova Pharmacy" className="h-10 mb-4" data-id="element-2876" data-mp="u0ic5syfw45z" />
            <p className="text-sm text-gray-600 mb-4" data-id="element-2877" data-mp="kysishkzyv5k">
              Your trusted source for premium healthcare products and pharmacy
              services.
            </p>
            <div className="flex space-x-3 mb-6" data-id="element-2878" data-mp="b14cqvhxy183">
              <a href="#" className="bg-[#1E2B55] text-white p-2 rounded-full hover:bg-[#162041] transition-colors" data-id="element-2879" data-mp="b2fih0uy5j1u">
                <FacebookIcon className="w-4 h-4" data-id="element-2880" data-mp="25enigsm4kq4h" />
              </a>
              <a href="#" className="bg-[#1E2B55] text-white p-2 rounded-full hover:bg-[#162041] transition-colors" data-id="element-2881" data-mp="2ae045a19fr5h">
                <InstagramIcon className="w-4 h-4" data-id="element-2882" data-mp="3uwkbqls5jgar" />
              </a>
              <a href="#" className="bg-[#1E2B55] text-white p-2 rounded-full hover:bg-[#162041] transition-colors" data-id="element-2883" data-mp="3pxpn337i6xiq">
                <TwitterIcon className="w-4 h-4" data-id="element-2884" data-mp="3pq05tztmtff" />
              </a>
              <a href="#" className="bg-[#1E2B55] text-white p-2 rounded-full hover:bg-[#162041] transition-colors" data-id="element-2885" data-mp="3oewdu6dllob">
                <YoutubeIcon className="w-4 h-4" data-id="element-2886" data-mp="dgaz5ijepzyv" />
              </a>
              <a href="#" className="bg-[#1E2B55] text-white p-2 rounded-full hover:bg-[#162041] transition-colors" data-id="element-2887" data-mp="rfahy9k8nkn4">
                <LinkedinIcon className="w-4 h-4" data-id="element-2888" data-mp="mh0nk16c8o2k" />
              </a>
            </div>
            <div className="space-y-2" data-id="element-2889" data-mp="2t7774lzbwt0d">
              <div className="flex items-start" data-id="element-2890" data-mp="2o7ki7fa51obq">
                <MapPinIcon className="w-4 h-4 text-[#1E2B55] mt-0.5 mr-2 flex-shrink-0" data-id="element-2891" data-mp="2o8vw47xascgk" />
                <p className="text-xs text-gray-600" data-id="element-2892" data-mp="jpyi8basddvw">
                  Riyadh, Kingdom of Saudi Arabia
                </p>
              </div>
              <div className="flex items-center" data-id="element-2893" data-mp="fnbualh8kd3z">
                <PhoneIcon className="w-4 h-4 text-[#1E2B55] mr-2 flex-shrink-0" data-id="element-2894" data-mp="tfrrv6rdbixi" />
                <p className="text-xs text-gray-600" data-id="element-2895" data-mp="oh86p8klmb67">+966 11 123 4567</p>
              </div>
              <div className="flex items-center" data-id="element-2896" data-mp="rw1ejse6n96">
                <MailIcon className="w-4 h-4 text-[#1E2B55] mr-2 flex-shrink-0" data-id="element-2897" data-mp="sfhduyhf1kk" />
                <p className="text-xs text-gray-600" data-id="element-2898" data-mp="3sx9kvsg4qcqc">
                  support@innovapharmacy.com
                </p>
              </div>
            </div>
          </div>
          {/* Column 2: Shop by Category */}
          <div data-id="element-2899" data-mp="5pnsjbl7q5cb">
            <h3 className="text-base font-semibold mb-4" data-id="element-2900" data-mp="5tbla8iu2npz">Shop by Category</h3>
            <ul className="space-y-2" data-id="element-2901" data-mp="1m3xejz1zfhzz">
              <li data-id="element-2902" data-mp="1h6e0az5ab581">
                <a href="/category/prescription-medicines" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2903" data-mp="1h6xaftop0pbi">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2904" data-mp="342vg2gwwc1wa" />
                  Prescription Medicines
                </a>
              </li>
              <li data-id="element-2905" data-mp="2q56s307j8en0">
                <a href="/category/vitamins-supplements" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2906" data-mp="2q5owwl89g16j">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2907" data-mp="3ist48wutsrlh" />
                  Vitamins & Supplements
                </a>
              </li>
              <li data-id="element-2908" data-mp="392zwk6xt0wmi">
                <a href="/category/personal-care" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2909" data-mp="391f2sjjbdhpp">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2910" data-mp="5l7we59il6d8" />
                  Personal Care
                </a>
              </li>
              <li data-id="element-2911" data-mp="adj0lkbafebl">
                <a href="/category/mother-baby" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2912" data-mp="k86mnwwmxuqd">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2913" data-mp="f9va3eeyh64g" />
                  Mother & Baby
                </a>
              </li>
              <li data-id="element-2914" data-mp="5bfk5ero02wj">
                <a href="/category/medical-devices" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2915" data-mp="59w51rhqvxwc">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2916" data-mp="3sngjaphra7qr" />
                  Medical Devices
                </a>
              </li>
              <li data-id="element-2917" data-mp="3np6pojbojf79">
                <a href="/category/health-wellness" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2918" data-mp="3nmkg6e58apme">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2919" data-mp="3dpxwvtsjw6mh" />
                  Health & Wellness
                </a>
              </li>
              <li data-id="element-2920" data-mp="1p7mrvvhmn33p">
                <a href="/category/beauty-skincare" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2921" data-mp="1p61xc5vbbk5u">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2922" data-mp="1y79vmnxtwkzx" />
                  Beauty & Skincare
                </a>
              </li>
              <li data-id="element-2923" data-mp="2363607htjvvv">
                <a href="/categories" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2924" data-mp="234i9wdfuw4vw">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2925" data-mp="1aiqinv3u3k1i" />
                  View All Categories
                </a>
              </li>
            </ul>
          </div>
          {/* Column 3: Quick Links */}
          <div data-id="element-2926" data-mp="1ka39qkht666h">
            <h3 className="text-base font-semibold mb-4" data-id="element-2927" data-mp="msmgls6anscm">Quick Links</h3>
            <ul className="space-y-2" data-id="element-2928" data-mp="mqiftj3oz9gk">
              <li data-id="element-2929" data-mp="rr64hy4g7e7m">
                <a href="/account" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2930" data-mp="rqo0gfbjnvp5">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2931" data-mp="2pfa18a0s886y" />
                  My Account
                </a>
              </li>
              <li data-id="element-2932" data-mp="337q337hy606a">
                <a href="/account/orders" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2933" data-mp="337zloa0nx51y">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2934" data-mp="3d3t6shsg66vc" />
                  Orders & Tracking
                </a>
              </li>
              <li data-id="element-2935" data-mp="38843q4h7y7ua">
                <a href="/account/wishlist" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2936" data-mp="3m5akxumanyhe">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2937" data-mp="3h4d2dgxdh2fd" />
                  Wishlist
                </a>
              </li>
              <li data-id="element-2938" data-mp="1msyaatgw2qwg">
                <a href="/cart" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2939" data-mp="1mthvcj1u5vep">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2940" data-mp="79h66xqbwzx1" />
                  Shopping Cart
                </a>
              </li>
              <li data-id="element-2941" data-mp="3pmovqr497xwd">
                <a href="/store-locator" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2942" data-mp="3pn81zakjkxuk">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2943" data-mp="3fo90qd23w4hl" />
                  Store Locator
                </a>
              </li>
              <li data-id="element-2944" data-mp="3km0t186nxsmb">
                <a href="/brands" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2945" data-mp="36ovppfyc37ur">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2946" data-mp="3aqh9zmd76oez" />
                  Shop by Brand
                </a>
              </li>
              <li data-id="element-2947" data-mp="18zcl2y2ng1yc">
                <a href="/offers" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2948" data-mp="18xt3n459bkuz">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2949" data-mp="2cwofhdlmg71h" />
                  Deals & Offers
                </a>
              </li>
              <li data-id="element-2950" data-mp="28vw2qadjjk0g">
                <a href="/about-us" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2951" data-mp="28vcy1vcwis4d">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2952" data-mp="30misbv5xxvlq" />
                  About Us
                </a>
              </li>
            </ul>
          </div>
          {/* Column 4: Customer Service */}
          <div data-id="element-2953" data-mp="2rsnu7738l5fl">
            <h3 className="text-base font-semibold mb-4" data-id="element-2954" data-mp="2rs4dftpbon35">Customer Service</h3>
            <ul className="space-y-2" data-id="element-2955" data-mp="2mu2t75g5uhq3">
              <li data-id="element-2956" data-mp="2mt1gyxnerp6s">
                <a href="/help-center" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2957" data-mp="3k9zxhirydc6k">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2958" data-mp="3fhghyg9pg6z4" />
                  Help Center
                </a>
              </li>
              <li data-id="element-2959" data-mp="3rt96hawjr8v3">
                <a href="/faq" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2960" data-mp="3rutzgw37qjqu">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2961" data-mp="4p32yol3vovo" />
                  FAQ
                </a>
              </li>
              <li data-id="element-2962" data-mp="9n4m19ij7o75">
                <a href="/contact-us" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2963" data-mp="9nmoinvseyni">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2964" data-mp="jdpfyjn9g4jq" />
                  Contact Us
                </a>
              </li>
              <li data-id="element-2965" data-mp="oc92al5rnicm">
                <a href="/track-order" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2966" data-mp="oev9gjoqvvub">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2967" data-mp="xe9yrft6e0d8" />
                  Track My Order
                </a>
              </li>
              <li data-id="element-2968" data-mp="1dpujz27fmtz1">
                <a href="/shipping-policy" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2969" data-mp="1dqdq7lnpztx8">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2970" data-mp="1nns6nl9n8ipj" />
                  Shipping Policy
                </a>
              </li>
              <li data-id="element-2971" data-mp="zyz7lfxq5uqp">
                <a href="/return-policy" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2972" data-mp="zyh2ruwzy876">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2973" data-mp="19p2964iwwh0n" />
                  Returns & Refunds
                </a>
              </li>
              <li data-id="element-2974" data-mp="14vfvc910i739">
                <a href="/terms-conditions" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2975" data-mp="h7g4za7m4ip7">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2976" data-mp="c6inz0yc9upa" />
                  Terms & Conditions
                </a>
              </li>
              <li data-id="element-2977" data-mp="2smygthuqgtqb">
                <a href="/privacy-policy" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2978" data-mp="2sngkv0nn0c8s">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2979" data-mp="2iwc5w0xyordy" />
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-2980" data-mp="36n98gn3vaccj">
                <a href="/report-issue" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2981" data-mp="36kn5z1vu2n16">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2982" data-mp="2xl8cdtkddwcg" />
                  Report an Issue
                </a>
              </li>
            </ul>
          </div>
        </div>
        {/* Payment Methods & Copyright - Desktop Only */}
        <div className="hidden md:block mt-10 pt-6 border-t border-gray-200" data-id="element-2983" data-mp="1q7ycxzlqcl99">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-2984" data-mp="1q5vcsmqv5bqt">
            <div className="w-full md:w-auto" data-id="element-2985" data-mp="pak4q3rh24hg">
              <h4 className="text-sm font-semibold mb-2 flex items-center justify-center md:justify-start" data-id="element-2986" data-mp="u6r9ht84t9xt">
                <CreditCardIcon className="w-4 h-4 mr-2 text-[#1E2B55]" data-id="element-2987" data-mp="ya75qogah89z" />
                Payment Methods
              </h4>
              <div className="flex items-center justify-center md:justify-start space-x-3 flex-wrap gap-y-2" data-id="element-2988" data-mp="137fnwp1ftcb8">
                <img src="https://cdn.niceonesa.com/web/assets_v2/images/visa.svg?v=2.1.18" alt="Visa" className="h-8 w-auto" data-id="element-2989" data-mp="6fvbged31ii4" />
                <img src="https://cdn.niceonesa.com/web/assets_v2/images/master-card.svg?v=2.1.18" alt="Mastercard" className="h-8 w-auto" data-id="element-2990" data-mp="fgjob5qqpctf" />
                <img src="https://cdn.niceonesa.com/web/assets_v2/images/mada.svg?v=2.1.18" alt="Mada" className="h-8 w-auto" data-id="element-2991" data-mp="3ixin6lyub5ry" />
                <img src="https://cdn.niceonesa.com/web/assets_v2/images/stc-pay.svg?v=2.1.18" alt="STC Pay" className="h-8 w-auto" data-id="element-2992" data-mp="3gcknn3gmphl4" />
                <img src="https://cdn.niceonesa.com/web/assets_v2/images/apple-pay.svg?v=2.1.18" alt="Apple Pay" className="h-8 w-auto" data-id="element-2993" data-mp="36ilnga0487vt" />
                <img src="https://cdn.niceonesa.com/web/assets_v2/images/tamara.svg?v=2.1.18" alt="Tamara" className="h-8 w-auto" data-id="element-2994" data-mp="2spch6i7gs2hi" />
              </div>
            </div>
            <div className="flex flex-col items-center md:items-end gap-2" data-id="element-2995" data-mp="2is7v0idmc70p">
              <div className="flex items-center gap-3 text-xs text-gray-600" data-id="element-2996" data-mp="2eq325luzvef4">
                <div className="flex items-center gap-1.5" data-id="element-2997" data-mp="29qi3lcjql82x">
                  <GlobeIcon className="w-3.5 h-3.5 text-[#1E2B55]" data-id="element-2998" data-mp="29r09l0w7b0o1" />
                  <span data-id="element-2999" data-mp="202mj57kf6tyt">Saudi Arabia (SAR)</span>
                </div>
                <span className="text-gray-300" data-id="element-3000" data-mp="244hii6isix9y">|</span>
                <a href="/en" className="hover:text-[#1E2B55] transition-colors font-medium" aria-current="true" data-id="element-3001" data-mp="24612a73nnqgh">
                  English
                </a>
                <span className="text-gray-300" data-id="element-3002" data-mp="1v5mcovjnrp76">·</span>
                <a href="/" className="hover:text-[#1E2B55] transition-colors" data-id="element-3003" data-mp="2iuosryyn99zk">
                  Arabic
                </a>
              </div>
              <p className="text-sm text-gray-600 text-center md:text-right" data-id="element-3004" data-mp="293kg55wfy17w">
                &copy; {new Date().getFullYear()} Innova Pharmacy. All rights
                reserved.
              </p>
            </div>
          </div>
        </div>
        {/* Copyright - Mobile Only */}
        <div className="md:hidden mt-4 pt-4 border-t border-gray-200" data-id="element-3005" data-mp="31q57i6cx2dbg">
          <p className="text-xs text-gray-600 text-center" data-id="element-3006" data-mp="36jq5hyeif7an">
            &copy; {new Date().getFullYear()} Innova Pharmacy. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}